export default __webpack_public_path__ + "assets/ee2d1dc8e48191ede35b9f5323280809.jpeg";